<template>
  <div class="view container">
    <el-row :gutter="20" type="flex">
      <el-col :xs="24">
        <h1 class="font--bigger m-t-0 c-black">
          <span>{{ $t('Settings') }}</span>
        </h1>
      </el-col>
    </el-row>

    <el-card>
      <el-row>
        <el-col :xs="24">
          <!-- Navigation -->
          <el-menu mode="horizontal" :router="true">
            <el-menu-item
              :index="item.href"
              v-for="item in items"
              :key="item.id"
              :class="{ 'is-active--custom-horizontal': itemIsInPath(item) }"
              >{{ $t(item.name) }}</el-menu-item
            >
          </el-menu>
        </el-col>
      </el-row>

      <el-row>
        <el-col :xs="24">
          <!-- Main content goes here -->
          <router-view class="p-t-2"></router-view>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Settings',

  data() {
    return {
      items: [
        {
          id: 1,
          name: 'Company',
          href: '/settings/company'
        },
        {
          id: 2,
          name: 'My Profile',
          href: '/settings/user'
        },
        {
          id: 3,
          name: 'Change password',
          href: '/settings/change-password'
        }
      ]
    };
  },

  methods: {
    itemIsInPath(item) {
      return item.href === this.$route.path;
    }
  }
};
</script>

<style lang="scss" scoped>
.is-active--custom-horizontal {
  border-bottom: 2px solid $c-brand !important;
  border-right-width: 0;
  border-left-width: 0;
}
</style>
